import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { commonActions, commonConstants as cc, PopinComponent } from 'srcReact/components'
import Button from 'srcReact/components/common2/Button'
import Modal from 'srcReact/components/common2/Modal'
import Spinner from 'srcReact/components/common2/Spinner'
import { messengerActions } from 'srcReact/MessengerPage'
import ManageMembers from '../ManageMembers'
import styles from './styles.module.scss'

const LeaveConversation = ({ closeModal }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    common: { isMobile },
    messenger: { openedConversation, loading },
    login: { user: loggedInUser }
  } = useSelector((state) => state)
  const [markLeft, setMarkLeft] = useState(false)
  const [markMuted, setMarkMuted] = useState(false)
  const [isSoleAdmin, setIsSoleAdmin] = useState(false)
  const [openManageMembers, setOpenManageMembers] = useState(false)

  useEffect(() => {
    if ((!loading && markLeft) || (!loading && markMuted)) {
      close()
      if (isMobile) {
        dispatch(messengerActions.showMainContent(false))
        dispatch(messengerActions.showSidebar(true))
      }
    }
  }, [loading])
  useEffect(() => {
    if (openedConversation && openedConversation.conversation.user_is_conversation_admin === 0) {
      return
    }
    if (openedConversation) {
      if (openedConversation.conversation.user_is_conversation_admin === 0) {
        return
      }
      const { active_users: activeUsers } = openedConversation
      const isAnotherAdminExists = activeUsers.some((u) => u.is_conversation_admin === 1 && u.id !== loggedInUser.id)
      if (isAnotherAdminExists) {
        return
      }
      setIsSoleAdmin(true)
    }
  }, [])

  const close = () => {
    closeModal()
    //dispatch({ type: cc.POPIN_CLOSE })
  }

  const leaveConversation = () => {
    if (openedConversation.conversation.id > 0) {
      setMarkLeft(true)
      dispatch(messengerActions.leaveConversation(openedConversation.conversation.id, loggedInUser.id.toString()))
    }
  }
  const muteConversation = () => {
    if (openedConversation.conversation.id > 0) {
      setMarkMuted(true)
      dispatch(messengerActions.muteConversation(openedConversation.conversation.id, loggedInUser.id.toString()))
    }
  }
  const closeManageMembers = () => {
    setOpenManageMembers(false)
    closeModal()
  }
  const conversationMuted = openedConversation && openedConversation.conversation.isMutedByUser === 1

  return (
    <React.Fragment>
      <h1 className={styles.title}>{t('messenger.header.leaveConversationTitle')}</h1>
      <h2 className={styles.warning}>{t('messenger.header.leaveConversationWarning')}</h2>
      <div className={styles.buttonOuterWrapper}>
        {!conversationMuted && (
          <Button
            size='large'
            customStyle={styles.muteButton}
            text={
              loading && markMuted ? (
                <Spinner customCss={styles.spinner} isWhite={true} />
              ) : (
                t('messenger.header.muteConversationButton')
              )
            }
            handleClick={muteConversation}
          />
        )}

        <div className={`${styles.rightButtons} ${conversationMuted && styles.centerButtons}`}>
          {!isMobile && <Button size='large' text={t('messenger.btnCancel1')} style='tertiary' handleClick={close} />}

          <Button
            style={conversationMuted ? 'primary' : 'tertiary'}
            size='large'
            text={
              loading && markLeft ? (
                <Spinner customCss={styles.spinner} />
              ) : isMobile ? (
                t('messenger.header.leaveConversationShort')
              ) : (
                t('messenger.header.leaveConversation')
              )
            }
            handleClick={leaveConversation}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default LeaveConversation
